var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-data-table", {
        attrs: { items: _vm.items, headers: _vm.headers, "single-expand": "" },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.accountCode.account_code))]),
                  _c("td", [_vm._v(_vm._s((item.amount || 0).phpFormat()))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            small: "",
                            color: "yellow darken-2",
                            dark: ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("input", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            text: "",
                            "x-small": "",
                            color: "blue-grey"
                          },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { class: isExpanded ? "is-expanded" : "" },
                            [_vm._v("mdi-chevron-down")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", { attrs: { colspan: _vm.headers.length } }, [
                    _c("span", [_vm._v(_vm._s(item.reason))])
                  ])
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }